<template>

    <b-row class="results-content-simulacro mt-3">
        <b-row class="results-content-simulacro-border">
            <b-col cols="12" lg="9" class="results-content-simulacro-center">
                    <b-row style="margin-bottom: -0.5rem;">
                    <b-col  cols="12">
                        <p class="results-title-simulacro-colegio ">{{item.colegio | upper}}</p>
                    </b-col>
                </b-row>
                <b-row style="margin-bottom: -0.5rem;">
                    <b-col  cols="12">
                        <p class="results-title-simulacro-nombre">{{item.nombre | upper}}</p>
                    </b-col>
                </b-row>
                <b-row >
                    <b-col  cols="12" lg="3" >
                        <p class="results-title-key">Key de acceso: {{ item.key }} </p>
                    </b-col>
                    <b-col  cols="12" lg="3" class="ml-5">
                        <p class="results-title-key">{{ item.desde  }}</p>
                    </b-col>
                    <b-col  cols="12" lg="6">
                    </b-col>
                </b-row>
            </b-col>
            <b-col cols="12" lg="3">
                <b-row>
                    <button class="button-primary-result  mr-3 mt-4" @click="goRouter('/'+ruta+'/data/' + item.key)">
                        <span class="button-text-result">VER DATA</span>
                    </button>
                </b-row>
            
            </b-col>
        </b-row>

    </b-row>
</template>
<script>
    export default {
        name: 'Results',
        props: {
            id: Number,
            item: Object,
            filterKey: String,
            ruta: String
        },
        methods: {
            goRouter(url) {
                this.$router.push(url)
            }
        },
        filters:{
            upper(value){
                return value.toUpperCase()
            }
        }
    }
</script>
<style scoped>

</style>
